import { PlayerEvents, StreamType, PlaybackMode, playerStateManager, HeartbeatEvents, PlayerStatus, AdActions, PlayerType } from '@4tn/core-audio-player-shared';
export { AdActions, PlaybackMode, PlayerEvents, PlayerStatus, PlayerType, StreamType, TealiumEventCategory, TealiumEventNames, VolumeEventLabel, playerStateManager } from '@4tn/core-audio-player-shared';
import { EventEmitter2 } from 'eventemitter2';
import Cookies from 'js-cookie';
import { TCString } from '@iabtcf/core';
import { configureUTag } from '@4tn/core-audio-player-analytics';
export { TealiumEvent, trackLink } from '@4tn/core-audio-player-analytics';
const streamTypes = {
  MOUNT_POINT_HD: "mount_point_hd",
  MOUNT_POINT: "mount_point",
  AUDIO_HLS: "audio_hls",
  AUDIO_ACC: "audio_aac",
  MP3_STREAM: "audio_mp3"
};
class Media {
  constructor(item) {
    if (item) {
      this.streamSource = item;
      this.slug = item.slug;
      this.duration = item.durationSeconds;
      this.contentType = item.contentTypeId;
      this.contentId = item.id;
      if (item.media && item.media.length > 0) {
        const itemMountPoint = item.media.filter(media => media.source === streamTypes.MOUNT_POINT)[0];
        const itemMountPointHD = item.media.filter(media => media.source === streamTypes.MOUNT_POINT_HD)[0];
        const audioAac = item.media.filter(mediaItem => mediaItem.source === streamTypes.AUDIO_ACC)[0];
        const audioHls = item.media.filter(mediaItem => mediaItem.source === streamTypes.AUDIO_HLS)[0];
        this.audioAac = audioAac == null ? void 0 : audioAac.uri;
        this.audioHls = audioHls == null ? void 0 : audioHls.uri;
        this.mountPoint = itemMountPoint ? itemMountPoint.uri : "";
        this.mountPointHD = itemMountPointHD ? itemMountPointHD.uri : "";
        const itemMp3Stream = item.media.filter(media => media.source === streamTypes.MP3_STREAM)[0];
        this.mp3Stream = itemMp3Stream ? itemMp3Stream.uri : "";
      }
    }
    Object.freeze(this);
  }
  getStreamSource() {
    return this.streamSource;
  }
}
const events = new EventEmitter2({
  wildcard: true
});
class EventDispatcher {
  static sendEvent(type, objParams) {
    events.emit(type, objParams);
  }
  static on(type, listener) {
    events.on(type, listener);
  }
  static once(type, listener) {
    events.once(type, listener);
  }
  static off(type, listener) {
    events.off(type, listener);
  }
  static removeListener(type, listener) {
    events.removeListener(type, listener);
  }
}
const INITIAL_CONFIG = {
  distTag: "",
  gdpr: 0,
  gdprConsent: "",
  userToken: "",
  hdStream: false,
  excludePreroll: false,
  newTealiumSetup: false,
  ttag: ""
};
const logger = (type, message) => {
  if (process.env.NODE_ENV === "development") {
    switch (type) {
      case "info":
        console.info(message);
        break;
      case "debug":
        console.debug(message);
        break;
      case "warning":
        console.warn(message);
        break;
      case "error":
        console.error(message);
        break;
      default:
        console.log(message);
    }
  }
};
var logger$1 = {
  log: function () {
    for (var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++) {
      messages[_key] = arguments[_key];
    }
    logger("log", messages);
  },
  info: function () {
    for (var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      messages[_key2] = arguments[_key2];
    }
    logger("info", messages);
  },
  debug: function () {
    for (var _len3 = arguments.length, messages = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      messages[_key3] = arguments[_key3];
    }
    logger("debug", messages);
  },
  warn: function () {
    for (var _len4 = arguments.length, messages = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      messages[_key4] = arguments[_key4];
    }
    logger("warning", messages);
  },
  error: function () {
    for (var _len5 = arguments.length, messages = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      messages[_key5] = arguments[_key5];
    }
    logger("error", messages);
  }
};
const _ListenerHandler = class {
  attachListener(target, eventName, listener) {
    target.addEventListener(eventName, listener);
    if (!_ListenerHandler.attachedListeners[eventName]) {
      _ListenerHandler.attachedListeners[eventName] = [];
    }
    _ListenerHandler.attachedListeners[eventName].push({
      listener,
      target
    });
  }
  detachListeners(target) {
    for (const listenerName in _ListenerHandler.attachedListeners) {
      (_ListenerHandler.attachedListeners[listenerName] || []).forEach(listenerObject => {
        if (listenerObject.target === target) {
          target.removeEventListener(listenerName, listenerObject.listener);
          _ListenerHandler.attachedListeners[listenerName] = [];
        }
      });
    }
  }
};
let ListenerHandler = _ListenerHandler;
ListenerHandler.attachedListeners = {};
class NetworkManager {
  constructor() {
    this.listenerHandler = new ListenerHandler();
    this.isNetworkConnected = navigator.onLine;
    this.onOnline = () => {
      if (this.isNetworkConnected) {
        return;
      }
      this.isNetworkConnected = true;
      if (this.reconnectCallback) {
        this.reconnectCallback();
      }
    };
    this.onOffline = () => {
      if (!this.isNetworkConnected) {
        return;
      }
      this.disconnectCallback();
      this.isNetworkConnected = false;
    };
  }
  listenConnectionChange() {
    this.listenerHandler.attachListener(window, "online", this.onOnline.bind(this));
    this.listenerHandler.attachListener(window, "offline", this.onOffline.bind(this));
  }
  setReconnectCallback(callback) {
    this.reconnectCallback = callback;
  }
  setDisconnectCallback(callback) {
    this.disconnectCallback = callback;
  }
  detachListeners() {
    this.listenerHandler.detachListeners(window);
  }
  isOnline() {
    return this.isNetworkConnected;
  }
}
class PlayerConnectionManager {
  constructor(player) {
    this.player = player;
    this.networkManager = new NetworkManager();
  }
  handleConnections() {
    this.networkManager.detachListeners();
    this.networkManager.listenConnectionChange();
    this.networkManager.setReconnectCallback(this.onNetworkReconnect.bind(this));
    this.networkManager.setDisconnectCallback(this.onNetworkDisconnect.bind(this));
  }
  sendReconnectingEvent() {
    EventDispatcher.sendEvent(PlayerEvents.PLAYER_RECONNECTING);
  }
  sendReconnectEvent() {
    EventDispatcher.sendEvent(PlayerEvents.PLAYER_RECONNECT, {
      name: PlayerEvents.PLAYER_RECONNECT,
      time: this.player.currentTime,
      volume: this.player.volumeLevel
    });
  }
  isOnline() {
    return this.networkManager.isOnline();
  }
  onNetworkDisconnect() {}
}
function isIOS() {
  return navigator.userAgent.match(/(iPhone)|(iPod)/i) !== null;
}
function isFirefox() {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.includes("firefox");
}
function isSafari() {
  return Boolean(navigator.vendor && navigator.vendor.indexOf("Apple") > -1 && navigator.userAgent && navigator.userAgent.indexOf("CriOS") === -1 && navigator.userAgent.indexOf("FxiOS") === -1);
}
function isOfflineOnFirefox() {
  const networkManager = new NetworkManager();
  return isFirefox() && !networkManager.isOnline();
}
const isAbortError = errorInfo => {
  var _a, _b, _c;
  return ((_a = errorInfo.error) == null ? void 0 : _a.name) === "AbortError" || errorInfo instanceof DOMException && ((_c = (_b = errorInfo.message) == null ? void 0 : _b.includes) == null ? void 0 : _c.call(_b, "The play() request was interrupted by a call to pause()"));
};
class PlayerEventManager {
  constructor() {
    this.listeners = {};
  }
  async dispacth(eventName, eventCallback) {
    return await new Promise((resolve, reject) => {
      const promiseExecutor = async () => {
        this.waitForEvent(eventName).then(() => resolve()).catch(reject);
        await eventCallback().catch(reject);
      };
      void promiseExecutor();
    });
  }
  waitForEvent(eventName) {
    return new Promise((resolve, reject) => {
      this.removeListener(eventName);
      this.removeListener(PlayerEvents.STREAM_ERROR);
      const handleEvent = eventPayload => {
        resolve(eventPayload);
      };
      EventDispatcher.once(eventName, handleEvent);
      this.addListener(eventName, handleEvent);
      const handleStreamError = error => {
        if (isAbortError(error)) {
          return;
        }
        reject(error);
      };
      EventDispatcher.once(PlayerEvents.STREAM_ERROR, handleStreamError);
      this.addListener(PlayerEvents.STREAM_ERROR, handleStreamError);
    });
  }
  addListener(listenerName, listenerCallback) {
    if (!this.listeners[listenerName]) {
      this.listeners[listenerName] = [listenerCallback];
    } else {
      this.listeners[listenerName].push(listenerCallback);
    }
  }
  removeListener(eventToRemove) {
    for (const key in this.listeners) {
      this.listeners[key].forEach(listener => {
        if (eventToRemove === key) {
          EventDispatcher.off(key, listener);
        }
      });
    }
    this.listeners[eventToRemove] = [];
  }
}
const playerEventManager = new PlayerEventManager();
const playerEventHandler = (eventName, eventCallback) => {
  return playerEventManager.dispacth(eventName, eventCallback);
};
class ConnectionManager$1 extends PlayerConnectionManager {
  constructor(player) {
    super(player);
    this.shouldTriggerReconnection = false;
    EventDispatcher.on(PlayerEvents.STREAM_STATUS, this.onStreamStatusChange.bind(this));
    EventDispatcher.on(PlayerEvents.STREAM_MUTE_STOP, () => {
      this.shouldTriggerReconnection = true;
    });
  }
  async onNetworkReconnect() {
    if (!this.shouldTriggerReconnection || isIOS() || isSafari()) {
      return;
    }
    try {
      this.sendReconnectingEvent();
      await playerEventHandler(PlayerEvents.STREAM_START, async () => {
        this.player.play();
      });
      this.sendReconnectEvent();
    } catch (error) {
      logger$1.error(error);
    }
    this.shouldTriggerReconnection = false;
  }
  onStreamStatusChange(event) {
    if (this.isOnline() || this.shouldTriggerReconnection) {
      return;
    }
    this.handleNetworkReconnection(event);
  }
  handleNetworkReconnection(event) {
    if (event.name === "LIVE_STOP" && (isIOS() || isSafari())) {
      this.handleBufferOut();
      return;
    }
    if (event.name === "LIVE_FAILED" && isOfflineOnFirefox()) {
      this.handleBufferOut();
      return;
    }
    if (event.name === "LIVE_BUFFERING" && this.player.isPlaying) {
      this.handleBufferOut();
    }
  }
  handleBufferOut() {
    void this.player.stop();
    this.shouldTriggerReconnection = true;
  }
  onNetworkDisconnect() {
    if (!this.player.isHls) {
      return;
    }
    void this.player.stop();
    this.shouldTriggerReconnection = true;
  }
}
const TRITON_SDK = "https://sdk.listenlive.co/web/2.9/td-sdk.min.js";
const TRITON_PLAYER = "cap_triton";
const TRITON_PLAYER_ID = "td_container";
var __defProp$2 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2) for (var prop of __getOwnPropSymbols$2(b)) {
    if (__propIsEnum$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
  }
  return a;
};
const DEFAULT_POLL_OPTIONS = {
  interval: 100,
  maxAttempts: 50,
  rejectOnTimeout: true
};
const executePoll = async function (condition) {
  let defaultOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let attempts = 0;
  let timerId;
  const optionsOverride = __spreadValues$2(__spreadValues$2({}, DEFAULT_POLL_OPTIONS), defaultOptions);
  const checkCondition = (resolve, reject) => {
    if (attempts >= optionsOverride.maxAttempts) {
      clearTimeout(timerId);
      if (optionsOverride.rejectOnTimeout) {
        return reject(false);
      }
      return resolve(false);
    }
    if (!condition()) {
      attempts++;
      timerId = setTimeout(checkCondition, optionsOverride.interval, resolve, reject);
      return;
    }
    clearTimeout(timerId);
    return resolve(true);
  };
  return await new Promise(checkCondition);
};
function getUriFromMediaObject(mediaObject, config) {
  const {
    mountPoint,
    mountPointHD,
    mp3Stream,
    audioAac,
    audioHls
  } = mediaObject;
  const {
    hdStream,
    userToken
  } = config;
  if (userToken && hdStream && mountPointHD) {
    return mountPointHD;
  }
  return mountPoint || audioHls || mp3Stream || audioAac || "";
}
function isTritonMedia(mediaObject) {
  const {
    mountPoint,
    audioHls
  } = mediaObject;
  return !!(mountPoint || audioHls);
}
const loadScript = url => {
  const script = document.createElement("script");
  script.src = url;
  script.async = true;
  document.body.appendChild(script);
  return script;
};
const JWPLAYER_SDK = "https://cdn.jwplayer.com/libraries/xbpgBeUj.js";
const PREROLL_ID = "preroll";
const timeStamp = Date.now();
const randomNumber = Math.floor(Math.random() * 1e7 + 1);
const loadSdk$1 = async () => await new Promise((resolve, reject) => {
  const script = loadScript(JWPLAYER_SDK);
  script.async = false;
  script.onload = () => {
    try {
      if (typeof window.jwplayer === "function") {
        resolve(0);
      }
    } catch (error) {
      reject(error);
    }
  };
  script.onerror = reject;
  document.head.appendChild(script);
});
const TALPA_CONSENT = {
  id: null,
  scope: null,
  name: "talpa_consent used for ttag",
  purposes: [2, 3, 4, 7, 9]
};
function getPurposesAllowed(purposes, gdprConsent) {
  if (!Array.isArray(purposes)) return false;
  const consentData = gdprConsent ? TCString.decode(gdprConsent) : null;
  if (!consentData) return false;
  return purposes.every(purpose => {
    return consentData.purposeConsents.has(purpose);
  });
}
const prerollConsentTag = gdprConsent => {
  if (getPurposesAllowed(TALPA_CONSENT == null ? void 0 : TALPA_CONSENT.purposes, gdprConsent)) {
    return 1;
  }
  return 0;
};
const getAdTag = (configParams, media) => {
  var _a;
  const talpaConsentValue = prerollConsentTag(configParams == null ? void 0 : configParams.gdprConsent);
  const duration = (media == null ? void 0 : media.contentTypeId) === StreamType.PODCAST ? (_a = media == null ? void 0 : media.durationSeconds) != null ? _a : 0 : 3600;
  const tagParameters = {
    prof: "506166:sanoma_sbs_ovp_js_live",
    nw: 506166,
    caid: "juke_partner_player_asset",
    vdur: duration,
    vprn: timeStamp,
    csid: "talpa_audio_partner_player_desktop",
    resp: "vast3",
    crtp: "vast3ap",
    flag: encodeURIComponent("+sltp+emcr+exvt+fbad"),
    talpa_consent: talpaConsentValue,
    _fw_gdpr: 1,
    _fw_gdpr_consent: configParams == null ? void 0 : configParams.gdprConsent
  };
  return "https://7b936.v.fwmrm.net/ad/g/1?prof=".concat(tagParameters.prof, "&nw=").concat(tagParameters.nw, "&caid=").concat(tagParameters.caid, "&vdur=").concat(tagParameters.vdur, "&vprn=").concat(tagParameters.vprn, "&csid=").concat(tagParameters.csid, "&pvrn=").concat(randomNumber, "&resp=").concat(tagParameters.resp, "&crtp=").concat(tagParameters.crtp, "&flag=").concat(tagParameters.flag, ";talpa_consent=").concat(tagParameters.talpa_consent, "&_fw_gdpr=").concat(tagParameters._fw_gdpr, "&_fw_gdpr_consent=").concat(configParams == null ? void 0 : configParams.gdprConsent, ";");
};
const config = () => {
  return {
    file: "/preroll.mp4",
    width: "300px",
    height: "100%",
    deferAds: {},
    allowFullscreen: false,
    stretching: "uniform",
    autostart: true,
    advertising: {
      client: "vast",
      adscheduleid: "Fd87bE12",
      vpaidcontrols: true
    }
  };
};
const shouldPlayAd = () => {
  const currentTime = Date.now();
  const lastAdPlayedTime = Cookies.get("lastAdPlayedTime");
  const lastAdPlayedTimeFormatted = lastAdPlayedTime ? Number.parseInt(lastAdPlayedTime) : null;
  return Boolean(!lastAdPlayedTimeFormatted || currentTime - lastAdPlayedTimeFormatted >= 30 * 60 * 1e3);
};
var __defProp$1 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1) for (var prop of __getOwnPropSymbols$1(b)) {
    if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
class TritonPlayer {
  constructor() {
    this.readyInternal = false;
    this.config = INITIAL_CONFIG;
    this.station = "";
    this.playerLoaded = false;
    this.isLiveAudio = true;
    this.playbackMode = PlaybackMode.LIVE_AUDIO;
    this.connectionManager = new ConnectionManager$1(this);
  }
  static getInstance() {
    if (!TritonPlayer.instance) {
      TritonPlayer.instance = new TritonPlayer();
    }
    TritonPlayer.instance.connectionManager.handleConnections();
    return TritonPlayer.instance;
  }
  handlePlay(uri, config, media, noPreroll) {
    const talpaConsent = "talpa_consent:".concat(prerollConsentTag(config == null ? void 0 : config.gdprConsent));
    const exculdePreroll = "player:nopreroll";
    const ttagValue = noPreroll ? "".concat(talpaConsent, ",").concat(exculdePreroll) : talpaConsent;
    this.config = __spreadProps$1(__spreadValues$1({}, config), {
      ttag: ttagValue
    });
    this.previousMedia = this.media;
    this.media = media;
    if (!this.playerLoaded) {
      return this.loadPlayerAndPlay(uri);
    }
    return this.handleUpdateSrc(uri);
  }
  async destroy() {
    clearTimeout(this.configurationTimer);
    if (!this.player) {
      return;
    }
    this.removeEventListeners();
    await executePoll(() => {
      var _a;
      return typeof ((_a = this.player) == null ? void 0 : _a.destroy) === "function";
    });
    this.player.destroy();
    this.readyInternal = false;
  }
  onPlayerReady() {
    this.readyInternal = true;
    this.addEventListeners();
  }
  tritonConfigure(uri) {
    var _a, _b, _c, _d, _e, _f;
    this.station = uri;
    const urlSearchParams = new URLSearchParams(window.location.search);
    const age = (_a = urlSearchParams.get("age")) != null ? _a : "";
    const dob = (_b = urlSearchParams.get("dob")) != null ? _b : "";
    const yob = (_c = urlSearchParams.get("yob")) != null ? _c : "";
    const gender = (_d = urlSearchParams.get("gender")) != null ? _d : "";
    const ip = (_e = urlSearchParams.get("ip")) != null ? _e : "";
    const idSyncStation = (_f = urlSearchParams.get("idSyncStation")) != null ? _f : this.station;
    const config = {
      coreModules: [],
      playerReady: () => {}
    };
    const mediaPlayerModule = {
      id: "MediaPlayer",
      playerId: TRITON_PLAYER_ID,
      techPriority: ["Html5"],
      isDebug: false,
      playerServicesRegion: "eu",
      geoTargeting: false,
      sbm: {
        active: true,
        aSyncCuePointFallback: true
      },
      idSync: {
        station: idSyncStation,
        age,
        dob,
        yob,
        gender,
        ip
      }
    };
    if (this.config.gdpr) {
      mediaPlayerModule.idSync.gdpr = this.config.gdpr;
    }
    if (this.config.gdprConsent) {
      mediaPlayerModule.idSync.gdpr_consent = this.config.gdprConsent;
    }
    if (this.media.audioHls) {
      mediaPlayerModule.hls = true;
    }
    config.coreModules.push(mediaPlayerModule);
    return new Promise(resolve => {
      config.playerReady = () => {
        this.onPlayerReady();
        resolve();
      };
      this.player = new window.TDSdk(config);
    });
  }
  play() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    if (!this.isReady()) {
      return;
    }
    const params = {};
    params.dist = (_a = this.config) == null ? void 0 : _a.distTag;
    if ((_b = this.config) == null ? void 0 : _b.gdpr) {
      params.gdpr = this.config.gdpr;
    }
    if ((_c = this.config) == null ? void 0 : _c.ttag) {
      params.ttag = "".concat(this.config.ttag);
    }
    if ((_d = this.config) == null ? void 0 : _d.gdprConsent) {
      params.gdpr_consent = this.config.gdprConsent;
    }
    if (((_e = this.config) == null ? void 0 : _e.userToken) && ((_f = this.config) == null ? void 0 : _f.hdStream)) {
      params.tdtok = this.config.userToken;
    }
    const {
      volumeLevel
    } = playerStateManager.getState();
    (_g = this.player) == null ? void 0 : _g.setVolume(volumeLevel != null ? volumeLevel : 1);
    (_i = (_h = this.player) == null ? void 0 : _h.play) == null ? void 0 : _i.call(_h, {
      mount: this.station,
      trackingParameters: params
    });
  }
  async resume() {
    throw new Error("Method resume not implemented.");
  }
  async stop() {
    clearTimeout(this.configurationTimer);
    await executePoll(() => {
      var _a;
      return typeof ((_a = this.player) == null ? void 0 : _a.stop) === "function";
    });
    const node = this.getPlayerNode();
    node == null ? void 0 : node.pause();
    this.player.stop();
  }
  pause() {
    const playerNode = this.getPlayerNode();
    if (!this.player || !playerNode) {
      return;
    }
    playerNode.pause();
    EventDispatcher.sendEvent(PlayerEvents.STREAM_PAUSE, {
      name: PlayerEvents.STREAM_PAUSE,
      player: TRITON_PLAYER,
      media: this.media,
      time: this.currentTime
    });
  }
  mute() {
    var _a, _b;
    if (!this.isReady()) {
      return;
    }
    (_b = (_a = this.player) == null ? void 0 : _a.mute) == null ? void 0 : _b.call(_a);
    EventDispatcher.sendEvent(PlayerEvents.STREAM_MUTED, {
      name: PlayerEvents.STREAM_MUTED,
      player: TRITON_PLAYER
    });
    EventDispatcher.sendEvent(PlayerEvents.STREAM_MUTE_STOP, {
      name: PlayerEvents.STREAM_MUTE_STOP,
      player: TRITON_PLAYER
    });
  }
  unmute() {
    var _a, _b;
    if (!this.isReady()) {
      return;
    }
    (_b = (_a = this.player) == null ? void 0 : _a.unMute) == null ? void 0 : _b.call(_a);
    EventDispatcher.sendEvent(PlayerEvents.STREAM_UNMUTE_START, {
      name: PlayerEvents.STREAM_UNMUTE_START,
      player: TRITON_PLAYER,
      isLiveAudio: true,
      uri: this.uri,
      media: this.media
    });
    EventDispatcher.sendEvent(PlayerEvents.STREAM_UNMUTED, {
      name: PlayerEvents.STREAM_UNMUTED,
      player: TRITON_PLAYER
    });
  }
  setVolume(level) {
    var _a, _b;
    if (!this.isReady()) {
      return;
    }
    (_b = (_a = this.player) == null ? void 0 : _a.setVolume) == null ? void 0 : _b.call(_a, level);
    EventDispatcher.sendEvent(PlayerEvents.VOLUME_CHANGED, {
      name: PlayerEvents.VOLUME_CHANGED,
      player: TRITON_PLAYER,
      volume: level
    });
  }
  seek(intent) {
    var _a, _b;
    if (!this.isReady()) {
      return;
    }
    (_b = (_a = this.player) == null ? void 0 : _a.seek) == null ? void 0 : _b.call(_a, intent);
  }
  isReady() {
    return this.readyInternal;
  }
  loadPlayerAndPlay(uri) {
    return this.tritonConfigure(uri).then(() => {
      this.playerLoaded = true;
      if (TritonPlayer.active) {
        this.play();
      }
    });
  }
  handleUpdateSrc(uri) {
    clearTimeout(this.configurationTimer);
    return new Promise(resolve => {
      this.configurationTimer = setTimeout(() => {
        void this.tritonConfigure(uri).then(resolve);
      }, 500);
    }).then(() => {
      if (TritonPlayer.active) {
        this.play();
      }
    });
  }
  isTritonUnmounted() {
    const uri = getUriFromMediaObject(this.media, this.config);
    return !this.isReady() || !TritonPlayer.active || uri !== this.station;
  }
  addEventListeners() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
    if (!this.player) {
      return;
    }
    (_b = (_a = this.player).addEventListener) == null ? void 0 : _b.call(_a, PlayerEvents.STREAM_START, this.onStreamStart.bind(this));
    (_d = (_c = this.player).addEventListener) == null ? void 0 : _d.call(_c, PlayerEvents.STREAM_STOP, this.onStreamStop.bind(this));
    (_f = (_e = this.player).addEventListener) == null ? void 0 : _f.call(_e, PlayerEvents.STREAM_STATUS, this.onStreamStatusChange.bind(this));
    (_h = (_g = this.player).addEventListener) == null ? void 0 : _h.call(_g, PlayerEvents.STREAM_CONFIG_ERROR, this.onStreamConfigError.bind(this));
    (_j = (_i = this.player).addEventListener) == null ? void 0 : _j.call(_i, PlayerEvents.STREAM_FAIL, this.onStreamFail.bind(this));
    (_l = (_k = this.player).addEventListener) == null ? void 0 : _l.call(_k, PlayerEvents.STREAM_ERROR, this.onStreamError.bind(this));
    (_n = (_m = this.player).addEventListener) == null ? void 0 : _n.call(_m, PlayerEvents.STREAM_CONFIG_LOAD_ERROR, this.onStreamConfigLoadError.bind(this));
    (_p = (_o = this.player).addEventListener) == null ? void 0 : _p.call(_o, PlayerEvents.TRACK_CUE_POINT, this.onTrackCuePoint.bind(this));
  }
  removeEventListeners() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
    if (!this.player) {
      return;
    }
    (_b = (_a = this.player).removeEventListener) == null ? void 0 : _b.call(_a, PlayerEvents.STREAM_START, this.onStreamStart.bind(this));
    (_d = (_c = this.player).removeEventListener) == null ? void 0 : _d.call(_c, PlayerEvents.STREAM_STOP, this.onStreamStop.bind(this));
    (_f = (_e = this.player).removeEventListener) == null ? void 0 : _f.call(_e, PlayerEvents.STREAM_STATUS, this.onStreamStatusChange.bind(this));
    (_h = (_g = this.player).removeEventListener) == null ? void 0 : _h.call(_g, PlayerEvents.STREAM_CONFIG_ERROR, this.onStreamConfigError.bind(this));
    (_j = (_i = this.player).removeEventListener) == null ? void 0 : _j.call(_i, PlayerEvents.STREAM_FAIL, this.onStreamFail.bind(this));
    (_l = (_k = this.player).removeEventListener) == null ? void 0 : _l.call(_k, PlayerEvents.STREAM_ERROR, this.onStreamError.bind(this));
    (_n = (_m = this.player).removeEventListener) == null ? void 0 : _n.call(_m, PlayerEvents.STREAM_CONFIG_LOAD_ERROR, this.onStreamConfigLoadError.bind(this));
    (_p = (_o = this.player).removeEventListener) == null ? void 0 : _p.call(_o, PlayerEvents.TRACK_CUE_POINT, this.onTrackCuePoint.bind(this));
  }
  onStreamStart() {
    if (!this.isReady()) {
      return;
    }
    EventDispatcher.sendEvent(PlayerEvents.HEARTBEAT, {
      name: HeartbeatEvents.START_HEARTBEAT,
      media: this.media
    });
    EventDispatcher.sendEvent(PlayerEvents.STREAM_START, {
      name: PlayerEvents.STREAM_START,
      player: TRITON_PLAYER,
      isLiveAudio: true,
      uri: this.uri,
      media: this.media
    });
  }
  onStreamStop() {
    const media = this.previousMedia || this.media;
    EventDispatcher.sendEvent(PlayerEvents.HEARTBEAT, {
      name: HeartbeatEvents.STOP_HEARTBEAT,
      media
    });
    EventDispatcher.sendEvent(PlayerEvents.STREAM_STOP, {
      name: PlayerEvents.STREAM_STOP,
      player: TRITON_PLAYER,
      media
    });
    this.previousMedia = this.media;
  }
  onStreamStatusChange(event) {
    var _a;
    logger$1.log("STATUS", event.data);
    const statusCode = (_a = event == null ? void 0 : event.data) == null ? void 0 : _a.code;
    EventDispatcher.sendEvent(PlayerEvents.STREAM_STATUS, {
      name: statusCode,
      media: this.media
    });
    switch (statusCode) {
      case "LIVE_PLAYING":
        if (!TritonPlayer.active) {
          void this.stop();
        }
        break;
      case "LIVE_STOP":
        break;
      case "LIVE_BUFFERING":
        if (!TritonPlayer.active) {
          void this.stop();
        }
        break;
      case "LIVE_CONNECTING":
        if (!TritonPlayer.active) {
          void this.stop();
        }
        break;
      case "LIVE_FAILED":
      case "PLAY_NOT_ALLOWED":
      case "STREAM_GEO_BLOCKED":
      case "STATION_NOT_FOUND":
        if (isOfflineOnFirefox() || this.isTritonUnmounted()) {
          return;
        }
        EventDispatcher.sendEvent(PlayerEvents.HEARTBEAT, {
          name: HeartbeatEvents.RESET_HEARTBEAT,
          media: this.media
        });
        EventDispatcher.sendEvent(PlayerEvents.STREAM_ERROR, __spreadProps$1(__spreadValues$1({
          name: statusCode
        }, this.config), {
          streamUrl: this.station
        }));
        break;
      case "LIVE_PAUSE":
        EventDispatcher.sendEvent(PlayerEvents.PLAYER_DISCONNECTED);
        EventDispatcher.sendEvent(PlayerEvents.STREAM_STOP, {
          name: PlayerEvents.STREAM_STOP,
          player: TRITON_PLAYER,
          media: this.media
        });
        EventDispatcher.sendEvent(PlayerEvents.HEARTBEAT, {
          name: HeartbeatEvents.STOP_HEARTBEAT,
          media: this.media
        });
        break;
    }
  }
  onStreamConfigError() {
    if (this.isTritonUnmounted()) {
      return;
    }
    EventDispatcher.sendEvent(PlayerEvents.STREAM_ERROR, __spreadProps$1(__spreadValues$1({
      name: PlayerEvents.STREAM_CONFIG_ERROR
    }, this.config), {
      streamUrl: this.station
    }));
  }
  onStreamFail() {
    if (isOfflineOnFirefox() || this.isTritonUnmounted()) {
      return;
    }
    EventDispatcher.sendEvent(PlayerEvents.STREAM_ERROR, __spreadProps$1(__spreadValues$1({
      name: PlayerEvents.STREAM_FAIL
    }, this.config), {
      streamUrl: this.station
    }));
  }
  onStreamError() {
    if (this.isTritonUnmounted()) {
      return;
    }
    EventDispatcher.sendEvent(PlayerEvents.STREAM_ERROR, __spreadProps$1(__spreadValues$1({
      name: PlayerEvents.STREAM_ERROR
    }, this.config), {
      streamUrl: this.station
    }));
  }
  onStreamConfigLoadError() {
    if (this.isTritonUnmounted()) {
      return;
    }
    EventDispatcher.sendEvent(PlayerEvents.STREAM_ERROR, __spreadProps$1(__spreadValues$1({
      name: PlayerEvents.STREAM_CONFIG_LOAD_ERROR
    }, this.config), {
      streamUrl: this.station
    }));
  }
  onTrackCuePoint(event) {
    if (!this.isReady()) {
      return;
    }
    EventDispatcher.sendEvent(PlayerEvents.TRACK_CUE_POINT, {
      name: PlayerEvents.TRACK_CUE_POINT,
      player: TRITON_PLAYER,
      cuePoint: event == null ? void 0 : event.data
    });
  }
  get duration() {
    const playerNode = this.getPlayerNode();
    if (!this.readyInternal || !playerNode) {
      return;
    }
    return playerNode.duration;
  }
  get volumeLevel() {
    var _a;
    if (!this.isReady()) {
      return 1;
    }
    const node = this.getPlayerNode();
    return (_a = node == null ? void 0 : node.volume) != null ? _a : void 0;
  }
  getPlayerNode() {
    var _a, _b;
    if (!this.isReady()) {
      return;
    }
    return (_b = (_a = this.player) == null ? void 0 : _a.MediaElement) == null ? void 0 : _b.audioNode;
  }
  get isPlaying() {
    if (!this.isReady()) {
      return false;
    }
    const node = this.getPlayerNode();
    return node ? !node.paused : false;
  }
  get currentTime() {
    var _a;
    if (!this.isReady()) {
      return 0;
    }
    const node = this.getPlayerNode();
    return (_a = node == null ? void 0 : node.currentTime) != null ? _a : 0;
  }
  get isMuted() {
    var _a;
    if (!this.isReady()) {
      return false;
    }
    const node = this.getPlayerNode();
    return (_a = node == null ? void 0 : node.muted) != null ? _a : false;
  }
  get isHls() {
    if (!this.isReady()) {
      return false;
    }
    return Boolean(this.media.audioHls);
  }
}
class ConnectionManager extends PlayerConnectionManager {
  constructor(player) {
    super(player);
    this.outOfBuffer = false;
    EventDispatcher.on(PlayerEvents.STREAM_STALLED, this.onStreamStalled.bind(this));
  }
  async onNetworkReconnect() {
    if (!this.outOfBuffer) {
      return;
    }
    try {
      this.sendReconnectingEvent();
      this.player.load();
      await playerEventHandler(PlayerEvents.STREAM_START, async () => {
        await this.player.play();
      });
      this.sendReconnectEvent();
    } catch (error) {
      logger$1.error(error);
    }
    this.outOfBuffer = false;
  }
  onStreamStalled() {
    if (this.isOnline() || this.outOfBuffer || !this.player.isPlaying || this.player.playbackMode === PlaybackMode.ON_DEMAND_CLIP) {
      return;
    }
    void this.player.stop(true);
    this.outOfBuffer = true;
  }
}
const AUDIO_PLAYER = "cap_audio";
function createAudioElement(uri) {
  const audioElement = document.createElement("audio");
  audioElement.src = uri;
  audioElement.setAttribute("preload", "none");
  audioElement.setAttribute("autoplay", "false");
  document.body.appendChild(audioElement);
  return audioElement;
}
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class AudioPlayer {
  constructor() {
    this.audioElement = null;
    this.config = INITIAL_CONFIG;
    this.currentPlayerStatus = PlayerStatus.IDLE;
    this.onPlaying = () => {
      var _a;
      if (!this.audioElement) {
        return;
      }
      if (this.currentPlayerStatus !== PlayerStatus.PLAY) {
        EventDispatcher.sendEvent(PlayerEvents.PLAYER_PLAYING, {
          name: PlayerEvents.PLAYER_PLAYING,
          player: AUDIO_PLAYER,
          isLiveAudio: ((_a = this.media) == null ? void 0 : _a.contentType) !== StreamType.PODCAST,
          uri: this.uri,
          media: this.media
        });
        EventDispatcher.sendEvent(PlayerEvents.HEARTBEAT, {
          name: HeartbeatEvents.START_HEARTBEAT,
          media: this.media
        });
      }
      this.currentPlayerStatus = PlayerStatus.PLAY;
    };
    this.onStreamPaused = () => {
      if (!this.audioElement) {
        return;
      }
      if (this.currentPlayerStatus !== PlayerStatus.PAUSE) {
        this.currentPlayerStatus = PlayerStatus.DISCONNECT;
        EventDispatcher.sendEvent(PlayerEvents.PLAYER_DISCONNECTED);
      }
      EventDispatcher.sendEvent(PlayerEvents.HEARTBEAT, {
        name: HeartbeatEvents.STOP_HEARTBEAT,
        media: this.media
      });
    };
    this.onStreamStart = () => {
      var _a;
      if (!this.audioElement) {
        return;
      }
      EventDispatcher.sendEvent(PlayerEvents.STREAM_START, {
        name: PlayerEvents.STREAM_START,
        player: AUDIO_PLAYER,
        isLiveAudio: ((_a = this.media) == null ? void 0 : _a.contentType) !== StreamType.PODCAST,
        uri: this.uri,
        media: this.media
      });
    };
    this.onEmptied = () => {
      if (!this.audioElement) {
        return;
      }
      EventDispatcher.sendEvent(PlayerEvents.PLAYER_EMPTIED, {
        name: PlayerEvents.PLAYER_EMPTIED,
        player: AUDIO_PLAYER,
        media: this.media
      });
    };
    this.onEnded = () => {
      if (!this.audioElement) {
        return;
      }
      EventDispatcher.sendEvent(PlayerEvents.HEARTBEAT, {
        name: HeartbeatEvents.RESET_HEARTBEAT,
        media: this.media
      });
      EventDispatcher.sendEvent(PlayerEvents.STREAM_ENDED, {
        time: this.audioElement.currentTime
      });
    };
    this.onTimeUpdate = () => {
      if (!this.audioElement) {
        return;
      }
      EventDispatcher.sendEvent(PlayerEvents.TIME_UPDATE, {
        name: PlayerEvents.TIME_UPDATE,
        time: this.audioElement.currentTime
      });
      EventDispatcher.sendEvent(PlayerEvents.HEARTBEAT, {
        name: HeartbeatEvents.UPDATE_TIME,
        time: this.audioElement.currentTime
      });
    };
    this.onVolumeChange = () => {
      if (!this.audioElement) {
        return;
      }
      EventDispatcher.sendEvent(PlayerEvents.VOLUME_CHANGED, {
        name: PlayerEvents.VOLUME_CHANGED,
        volume: this.audioElement.volume
      });
    };
    this.onDurationChange = () => {
      if (!this.audioElement) {
        return;
      }
      EventDispatcher.sendEvent(PlayerEvents.DURATION_CHANGE, {
        name: PlayerEvents.DURATION_CHANGE,
        duration: this.audioElement.duration
      });
    };
    this.onLoadedMetadata = () => {
      var _a;
      EventDispatcher.sendEvent(PlayerEvents.STREAM_METADATA_LOADED, {
        name: PlayerEvents.STREAM_METADATA_LOADED,
        player: AUDIO_PLAYER,
        duration: (_a = this.audioElement) == null ? void 0 : _a.duration,
        media: this.media
      });
    };
    this.onStalled = () => {
      if (!this.audioElement) {
        return;
      }
      EventDispatcher.sendEvent(PlayerEvents.STREAM_STALLED, {
        name: PlayerEvents.STREAM_STALLED,
        media: this.media
      });
    };
    this.onStreamError = () => {
      if (isOfflineOnFirefox() || !this.audioElement || !AudioPlayer.active) {
        return;
      }
      EventDispatcher.sendEvent(PlayerEvents.HEARTBEAT, {
        name: HeartbeatEvents.RESET_HEARTBEAT,
        media: this.media
      });
      EventDispatcher.sendEvent(PlayerEvents.STREAM_ERROR, __spreadProps(__spreadValues({
        name: PlayerEvents.STREAM_ERROR
      }, this.config), {
        streamUrl: this.uri,
        time: this.audioElement.currentTime
      }));
    };
    this.connectionManager = new ConnectionManager(this);
  }
  async destroy() {
    this.removeEventListeners();
    this.audioElement = null;
  }
  static getInstance() {
    if (!AudioPlayer.instance) {
      AudioPlayer.instance = new AudioPlayer();
    }
    AudioPlayer.instance.connectionManager.handleConnections();
    return AudioPlayer.instance;
  }
  handlePlay(uri, config, media) {
    this.config = config;
    this.media = media;
    this.uri = uri;
    if (!this.audioElement) {
      return this.handleLoad();
    }
    return this.handleUpdateSrc();
  }
  handleLoad() {
    this.audioElement = createAudioElement(this.uri);
    this.addEventListeners();
    if (this.config.currentTime !== void 0) {
      this.audioElement.currentTime = this.config.currentTime;
    }
    this.load();
    return this.play();
  }
  load() {
    if (!this.audioElement) {
      return;
    }
    this.audioElement.load();
  }
  async play() {
    if (!this.audioElement) {
      return;
    }
    if (this.config.currentTime) {
      this.audioElement.currentTime = this.config.currentTime;
    }
    const {
      volumeLevel
    } = playerStateManager.getState();
    this.audioElement.volume = volumeLevel != null ? volumeLevel : 1;
    this.audioElement.muted = false;
    const playPromise = this.audioElement.play();
    if (playPromise === void 0) {
      this.onStreamStart();
      return Promise.resolve();
    }
    return await playPromise.then(this.onStreamStart.bind(this)).catch(async error => {
      if (isAbortError(error)) {
        return;
      }
      return Promise.reject(error);
    });
  }
  async resume() {
    if (!this.audioElement) {
      return;
    }
    try {
      await this.audioElement.play();
      EventDispatcher.sendEvent(PlayerEvents.STREAM_RESUMED, {
        name: PlayerEvents.STREAM_RESUMED,
        player: AUDIO_PLAYER,
        contentType: this.media.contentType,
        time: this.audioElement.currentTime
      });
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async stop() {
    let disconnected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (!this.audioElement) {
      return;
    }
    this.audioElement.pause();
    this.audioElement.currentTime = 0;
    this.currentPlayerStatus = disconnected ? PlayerStatus.DISCONNECT : PlayerStatus.PAUSE;
    EventDispatcher.sendEvent(PlayerEvents.STREAM_STOP, {
      name: PlayerEvents.STREAM_STOP,
      player: AUDIO_PLAYER,
      media: this.media,
      time: this.audioElement.currentTime
    });
  }
  pause() {
    if (!this.audioElement) {
      return;
    }
    this.audioElement.pause();
    this.currentPlayerStatus = PlayerStatus.PAUSE;
    EventDispatcher.sendEvent(PlayerEvents.STREAM_PAUSE, {
      name: PlayerEvents.STREAM_PAUSE,
      player: AUDIO_PLAYER,
      media: this.media,
      time: this.audioElement.currentTime
    });
  }
  mute() {
    if (!this.audioElement) {
      return;
    }
    this.audioElement.muted = true;
    EventDispatcher.sendEvent(PlayerEvents.STREAM_MUTED, {
      name: PlayerEvents.STREAM_MUTED,
      player: AUDIO_PLAYER,
      time: this.audioElement.currentTime
    });
  }
  unmute() {
    if (!this.audioElement) {
      return;
    }
    this.audioElement.muted = false;
    EventDispatcher.sendEvent(PlayerEvents.STREAM_UNMUTED, {
      name: PlayerEvents.STREAM_UNMUTED,
      player: AUDIO_PLAYER,
      time: this.audioElement.currentTime
    });
  }
  setVolume(level) {
    if (!this.audioElement) {
      return;
    }
    this.audioElement.volume = level;
  }
  seek(intent) {
    if (!this.audioElement) {
      return;
    }
    this.audioElement.currentTime = intent;
  }
  handleUpdateSrc() {
    if (!this.audioElement) {
      return Promise.resolve();
    }
    this.audioElement.src = this.uri;
    this.config.currentTime = void 0;
    return this.play();
  }
  addEventListeners() {
    if (!this.audioElement) {
      return;
    }
    this.audioElement.addEventListener("playing", this.onPlaying);
    this.audioElement.addEventListener("pause", this.onStreamPaused);
    this.audioElement.addEventListener("stalled", this.onStalled);
    this.audioElement.addEventListener("emptied", this.onEmptied);
    this.audioElement.addEventListener("ended", this.onEnded);
    this.audioElement.addEventListener("timeupdate", this.onTimeUpdate);
    this.audioElement.addEventListener("volumechange", this.onVolumeChange);
    this.audioElement.addEventListener("durationchange", this.onDurationChange);
    this.audioElement.addEventListener("loadedmetadata", this.onLoadedMetadata);
    this.audioElement.addEventListener("error", this.onStreamError);
  }
  removeEventListeners() {
    if (!this.audioElement) {
      return;
    }
    this.audioElement.removeEventListener("playing", this.onPlaying);
    this.audioElement.removeEventListener("pause", this.onStreamPaused);
    this.audioElement.removeEventListener("stalled", this.onStalled);
    this.audioElement.removeEventListener("emptied", this.onEmptied);
    this.audioElement.removeEventListener("ended", this.onEnded);
    this.audioElement.removeEventListener("timeupdate", this.onTimeUpdate);
    this.audioElement.removeEventListener("volumechange", this.onVolumeChange);
    this.audioElement.removeEventListener("durationchange", this.onDurationChange);
    this.audioElement.removeEventListener("loadedmetadata", this.onLoadedMetadata);
    this.audioElement.removeEventListener("error", this.onStreamError);
  }
  get duration() {
    if (!this.audioElement) {
      return 0;
    }
    return this.audioElement.duration;
  }
  get volumeLevel() {
    if (!this.audioElement) {
      return 0;
    }
    return this.audioElement.volume;
  }
  get isPlaying() {
    if (!this.audioElement) {
      return false;
    }
    return !this.audioElement.paused;
  }
  get currentTime() {
    if (!this.audioElement) {
      return 0;
    }
    return this.audioElement.currentTime;
  }
  get isMuted() {
    if (!this.audioElement) {
      return false;
    }
    return this.audioElement.muted;
  }
  get isLiveAudio() {
    var _a;
    if (!this.audioElement) {
      return false;
    }
    return ((_a = this.media) == null ? void 0 : _a.contentType) !== StreamType.PODCAST;
  }
  get playbackMode() {
    var _a, _b;
    return ((_a = this.media) == null ? void 0 : _a.contentType) === StreamType.PODCAST || ((_b = this.media) == null ? void 0 : _b.contentType) === StreamType.CLIP ? PlaybackMode.ON_DEMAND_CLIP : PlaybackMode.LIVE_AUDIO;
  }
}
const handleVastPlay = async (media, config$1, audioPlayerCallback) => {
  const tag = getAdTag(config$1, media);
  const jwPlayerSetup = config();
  const jwPlayer = window.jwplayer(PREROLL_ID).setup(jwPlayerSetup);
  jwPlayer.on("ready", () => {
    try {
      localStorage.setItem("jwplayer.mute", "false");
    } catch (error) {
      logger$1.error("Failed to set 'jwplayer.mute' in localStorage");
    }
    jwPlayer == null ? void 0 : jwPlayer.playAd(tag);
  });
  jwPlayer.on("adBreakStart", () => {
    EventDispatcher.sendEvent(AdActions.AD_START);
  });
  jwPlayer.on("adComplete", () => {
    jwPlayer == null ? void 0 : jwPlayer.remove();
    Cookies.set("lastAdPlayedTime", Date.now().toString(), {
      expires: 30 * 60
    });
    audioPlayerCallback().then(() => EventDispatcher.sendEvent(AdActions.AD_STOP)).catch(() => EventDispatcher.sendEvent(AdActions.AD_ERRORED));
  });
  jwPlayer.on("adError", () => {
    jwPlayer == null ? void 0 : jwPlayer.remove();
    audioPlayerCallback().then(() => EventDispatcher.sendEvent(AdActions.AD_STOP)).catch(() => EventDispatcher.sendEvent(AdActions.AD_ERRORED));
  });
  jwPlayer.on("adBlock", () => {
    jwPlayer == null ? void 0 : jwPlayer.remove();
    audioPlayerCallback().then(() => EventDispatcher.sendEvent(AdActions.AD_BLOCKER_DETECTED)).catch(() => EventDispatcher.sendEvent(AdActions.AD_ERRORED));
  });
  jwPlayer.on("playAttempt", () => {
    jwPlayer == null ? void 0 : jwPlayer.remove();
    EventDispatcher.sendEvent(AdActions.AD_STOP);
  });
  jwPlayer.on("adImpression", () => {
    const prerollDiv = document.getElementById("preroll");
    const overlay = document.getElementById("overlay");
    if (!prerollDiv) {
      return;
    }
    prerollDiv.style.opacity = "1";
    if (overlay) {
      overlay.style.opacity = "0.8";
    }
  });
  jwPlayer.on("stop", () => {
    jwPlayer == null ? void 0 : jwPlayer.remove();
    EventDispatcher.sendEvent(AdActions.AD_STOP);
  });
  jwPlayer.on("error", () => {
    jwPlayer == null ? void 0 : jwPlayer.remove();
    audioPlayerCallback().then(() => EventDispatcher.sendEvent(AdActions.AD_STOP)).catch(() => EventDispatcher.sendEvent(AdActions.AD_ERRORED));
  });
  jwPlayer.on("setupError", () => {
    jwPlayer == null ? void 0 : jwPlayer.remove();
    audioPlayerCallback().then(() => EventDispatcher.sendEvent(AdActions.AD_STOP)).catch(() => EventDispatcher.sendEvent(AdActions.AD_ERRORED));
  });
};
EventDispatcher.on(PlayerEvents.STREAM_ERROR, () => {
  const overlay = document.getElementById("overlay");
  if (overlay) {
    overlay.remove();
  }
});
var name = "@4tn/core-audio-player-v2";
var version = "2.1.2";
var description = "Core Talpa Audio Player V2";
var author = "n.zlicic <nikola.zlicic@aws.talpanetwork.com>";
var homepage = "https://gitlab.com/4TN/tech/audio/audio-web-components/core-audio-player#readme";
var license = "UNLICENSED";
var main = "lib/index.js";
var typings = "lib/index.d.ts";
var repository = {
  type: "git",
  url: "git+https://gitlab.com/4TN/tech/audio/audio-web-components/core-audio-player.git"
};
var scripts = {
  build: "rm -rf lib && rollup --config scripts/rollup.config.js",
  "build:watch": "rm -rf lib && rollup --config scripts/rollup.config.js -w",
  "eslint:fix": "eslint src --fix",
  eslint: "eslint src",
  "tsc:build": "tsc --build",
  test: "jest",
  "test:watch": "npm test -- --watch",
  "test:coverage": "npm test -- --coverage",
  "test:ci": "npm test -- --ci --coverage --reporters=jest-junit",
  format: "prettier --write \"src/**/*.ts\""
};
var dependencies = {
  "@4tn/core-audio-player-analytics": "1.0.5",
  "@4tn/core-audio-player-shared": "1.0.5",
  "@iabtcf/core": "^1.5.5",
  eventemitter2: "^6.4.5",
  "js-cookie": "3.0.1",
  "prop-types": "^15.7.2"
};
var devDependencies = {
  "@babel/core": "^7.15.8",
  "@babel/plugin-syntax-jsx": "^7.16.0",
  "@babel/plugin-transform-runtime": "^7.16.0",
  "@babel/preset-env": "^7.16.0",
  "@babel/preset-typescript": "^7.16.0",
  "@babel/runtime": "^7.15.4",
  "@jest/core": "^27.5.1",
  "@rollup/plugin-babel": "^5.3.0",
  "@rollup/plugin-json": "^6.0.0",
  "@testing-library/dom": "^8.11.3",
  "@testing-library/jest-dom": "^5.15.0",
  "@testing-library/user-event": "^13.5.0",
  "@types/jest": "^27.5.2",
  "@types/js-cookie": "^3.0.3",
  "@typescript-eslint/eslint-plugin": "^5.53.0",
  "babel-jest": "^27.3.1",
  eslint: "^8.34.0",
  "eslint-config-standard-with-typescript": "^34.0.0",
  "eslint-plugin-import": "^2.27.5",
  "eslint-plugin-n": "^15.6.1",
  "eslint-plugin-promise": "^6.1.1",
  jest: "^27.5.1",
  "jest-junit": "^13.0.0",
  rollup: "^2.58.0",
  "rollup-plugin-delete": "^2.0.0",
  "rollup-plugin-dts": "^4.0.0",
  "rollup-plugin-esbuild": "^4.5.0",
  "rollup-plugin-includepaths": "^0.2.4",
  typescript: "^4.9.5"
};
var jest = {
  moduleNameMapper: {
    "@4tn/core-audio-player-analytics": "<rootDir>/../core-audio-player-analytics/src/index.ts",
    "@4tn/core-audio-player-shared": "<rootDir>/../core-audio-player-shared/src/index.ts"
  },
  verbose: true,
  collectCoverage: false,
  collectCoverageFrom: ["src/**", "!src/@types/**", "!**/*.d.ts", "!**/node_modules/**", "!**/index.*", "!**/*.snap"],
  coverageDirectory: "<rootDir>/coverage/",
  coverageThreshold: {
    global: {
      branches: 0,
      functions: 0,
      lines: 0,
      statements: 0
    }
  },
  coverageReporters: ["html", "lcov", "text"],
  moduleDirectories: ["node_modules", "src"],
  setupFilesAfterEnv: ["<rootDir>/src/@utils/jest-setup.ts"],
  coveragePathIgnorePatterns: ["node_modules", "<rootDir>/src/utils/"],
  testEnvironment: "jsdom"
};
var packageJson = {
  name: name,
  version: version,
  description: description,
  author: author,
  homepage: homepage,
  license: license,
  main: main,
  typings: typings,
  repository: repository,
  scripts: scripts,
  dependencies: dependencies,
  devDependencies: devDependencies,
  jest: jest
};
const analyticsMiddleware = eventDispatcher => {
  var _a;
  playerStateManager.setState({
    trackStreamStart: true,
    playerVersion: (_a = packageJson) == null ? void 0 : _a.version
  });
  let contentId;
  eventDispatcher.on(PlayerEvents.STREAM_START, event => {
    const {
      trackStreamStart
    } = playerStateManager.getState();
    playerStateManager.setState({
      trackStreamStart: trackStreamStart || contentId !== event.media.contentId
    });
    contentId = event.media.contentId;
  });
  eventDispatcher.on(PlayerEvents.STREAM_ENDED, () => {
    playerStateManager.setState({
      trackStreamStart: true
    });
  });
  eventDispatcher.on(PlayerEvents.STREAM_STOP, event => {
    var _a2;
    const isStation = ((_a2 = event == null ? void 0 : event.media) == null ? void 0 : _a2.contentType) === StreamType.STATION;
    playerStateManager.setState({
      trackStreamStart: !isStation
    });
  });
  eventDispatcher.on(PlayerEvents.PLAYER_DISCONNECTED, () => {
    playerStateManager.setState({
      trackStreamStart: false
    });
  });
  eventDispatcher.on(PlayerEvents.STREAM_ERROR, () => {
    playerStateManager.setState({
      trackStreamStart: true
    });
  });
  return configureUTag(eventDispatcher);
};
const loadSdk = async () => {
  const script = loadScript(TRITON_SDK);
  script.async = false;
  await new Promise((resolve, reject) => {
    script.onload = resolve;
    script.onerror = reject;
  });
};
const _CoreAudioPlayer = class {
  constructor() {
    this._isLoading = false;
    this.player = null;
    this.sdksLoaded = false;
    void this.loadSdks().then(() => {
      this.sdksLoaded = true;
    });
  }
  static getInstance() {
    if (!_CoreAudioPlayer.instance) {
      _CoreAudioPlayer.instance = new _CoreAudioPlayer();
    }
    return _CoreAudioPlayer.instance;
  }
  init() {
    analyticsMiddleware(EventDispatcher);
  }
  async play(media, config) {
    if (!this.sdksLoaded) {
      await executePoll(() => this.sdksLoaded);
    }
    this.setActivePlayer(media);
    if (this.media) {
      await this.stop();
      await this.handleDestroy(media);
    }
    if (this.media && this.media.id !== media.id) {
      EventDispatcher.sendEvent(PlayerEvents.STREAM_SWITCH, {
        name: PlayerEvents.STREAM_SWITCH,
        player: this.playerType,
        media: new Media(media)
      });
    }
    this.media = media;
    this.config = config;
    this._isLoading = true;
    if (!this.config.excludePreroll && shouldPlayAd()) {
      this.noPreroll = true;
      return handleVastPlay(this.media, this.config, this.handleStreamPlay.bind(this));
    }
    this.noPreroll = false;
    return this.handleStreamPlay();
  }
  async resume() {
    var _a;
    if (!this.isReady()) {
      return;
    }
    this._isLoading = true;
    try {
      if (!((_a = this.config) == null ? void 0 : _a.excludePreroll) && shouldPlayAd()) {
        await handleVastPlay(this.media, this.config, this.player.resume.bind(this.player)).finally(() => {
          this._isLoading = false;
        });
        return;
      }
      await this.player.resume().finally(() => {
        this._isLoading = false;
      });
    } catch (error) {
      EventDispatcher.sendEvent(PlayerEvents.STREAM_ERROR, {
        name: PlayerEvents.STREAM_ERROR
      });
      throw error;
    }
  }
  async stop() {
    const activePlayer = this.getPlayerByMedia(this.media);
    return activePlayer == null ? void 0 : activePlayer.stop().finally(() => {
      this.player = null;
    });
  }
  pause() {
    if (!this.isReady()) {
      return;
    }
    this.player.pause();
  }
  mute() {
    if (!this.isReady()) {
      return;
    }
    this.player.mute();
  }
  unmute() {
    if (!this.isReady()) {
      return;
    }
    this.player.unmute();
  }
  setVolumeLevel(level) {
    if (!this.isReady()) {
      return;
    }
    playerStateManager.setState({
      volumeLevel: level
    });
    if ((!this.player.volumeLevel || this.player.volumeLevel !== 0) && level === 0) {
      this.player.mute();
    }
    if ((!this.player.volumeLevel || this.player.volumeLevel === 0) && level > 0) {
      this.player.setVolume(level);
      this.player.unmute();
    } else {
      this.player.setVolume(level);
    }
  }
  seek(intent) {
    if (!this.isReady()) {
      return;
    }
    this.player.seek(intent);
  }
  isReady() {
    return Boolean(this.player) && this.sdksLoaded;
  }
  handleDestroy(media) {
    const mediaObject = new Media(media);
    if (isTritonMedia(mediaObject) && AudioPlayer.active) {
      return AudioPlayer.getInstance().destroy();
    }
    return TritonPlayer.getInstance().destroy();
  }
  getPlayerByMedia(media) {
    const mediaObject = new Media(media);
    if (isTritonMedia(mediaObject)) {
      return TritonPlayer.getInstance();
    }
    return AudioPlayer.getInstance();
  }
  setActivePlayer(media) {
    const mediaObject = new Media(media);
    if (isTritonMedia(mediaObject)) {
      TritonPlayer.active = true;
      AudioPlayer.active = false;
      return;
    }
    TritonPlayer.active = false;
    AudioPlayer.active = true;
  }
  handleStreamPlay() {
    return playerEventHandler(PlayerEvents.STREAM_START, async () => {
      const mediaObject = new Media(this.media);
      const uri = getUriFromMediaObject(mediaObject, this.config);
      if (this.config.volume) {
        playerStateManager.setState({
          volumeLevel: this.config.volume
        });
      }
      if (!uri) {
        const ERROR_MESSAGE = "Unsupported media format";
        EventDispatcher.sendEvent(PlayerEvents.STREAM_ERROR, {
          name: PlayerEvents.STREAM_ERROR,
          player: "Core Audio Player",
          error: ERROR_MESSAGE
        });
        throw new Error(ERROR_MESSAGE);
      }
      this.player = this.getPlayerByMedia(this.media);
      return this.player.handlePlay(uri, this.config, mediaObject, this.noPreroll);
    }).catch(error => {
      EventDispatcher.sendEvent(PlayerEvents.STREAM_ERROR, {
        name: PlayerEvents.STREAM_ERROR,
        error
      });
      throw error;
    }).finally(() => {
      this._isLoading = false;
    });
  }
  async loadSdks() {
    await loadSdk$1();
    await loadSdk();
  }
  get duration() {
    if (!this.isReady()) {
      return;
    }
    return this.player.duration;
  }
  get volume() {
    if (!this.isReady()) {
      return;
    }
    return this.player.volumeLevel;
  }
  get currentTime() {
    if (!this.isReady()) {
      return;
    }
    return this.player.currentTime;
  }
  get isPlaying() {
    if (!this.isReady()) {
      return;
    }
    return this.player.isPlaying;
  }
  get isLiveAudio() {
    if (!this.isReady()) {
      return;
    }
    return this.player.isLiveAudio;
  }
  get playbackMode() {
    if (!this.isReady()) {
      return;
    }
    return this.player.playbackMode;
  }
  get isMuted() {
    if (!this.isReady()) {
      return;
    }
    return this.player.isMuted;
  }
  get playerType() {
    if (!this.isReady()) {
      return;
    }
    if (TritonPlayer.active) {
      return PlayerType.TRITON;
    }
    return PlayerType.AUDIO;
  }
  get isLoading() {
    if (!this.isReady()) {
      return false;
    }
    return this._isLoading;
  }
};
let CoreAudioPlayer = _CoreAudioPlayer;
CoreAudioPlayer.instance = null;
const player = CoreAudioPlayer.getInstance();
export { events, player };